import router from "@/router";
import {getField, updateField} from 'vuex-map-fields';
import CustomerService from "../../services/customer.service";
import AppService from "@/services/app.service";

const state = () => ({
    blockReason: '',
});
const mutations = {
    clearBlockReason(state) {
        state.blockReason = '';
    },
    updateField
};
const actions = {
    updateBlockStatus({state, commit, dispatch, rootState}) {
        let senderId = router.currentRoute.params.senderId,
            botCode = router.currentRoute.params.bot_code;
        return CustomerService.updateCustomerBlockStatus(botCode, senderId, !rootState.customer.currentCustomer['block_status'], state.blockReason)
            .then(() => {
                commit('clearBlockReason')
                AppService.toastInfo('Customer block status update success')
            })
            .catch(() => {
                AppService.toastError('Customer block status failed')
            })
            .finally(() => {
                dispatch('dialog/closeDialogBlockCustomer', null, {root: true})
        })
    }
};
const getters = {getField};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
